import { ValidationRule } from 'react-hook-form';
import { IFixedTermItem } from '../types/IFixedTermItem';
import { ICBU } from '../types/ICBU';
import { required } from '@bpba/form-components';
import {
  CBU_CVU_PATTERN,
  CBU_CVU_PATTERN_MESSAGE,
  CBU_PATTERN_OTHER_BANKS,
  CBU_ALIAS_MAX_LENGTH,
  CBU_ALIAS_MIN_LENGTH,
  CBU_ALIAS_PATTERN,
  CBU_INVALID_PATTERN_MESSAGE,
  CBU_LENGTH,
  CBU_LENGTH_MESSAGE,
  INPUT_INVALID_FORMAT_MESSAGE,
  INTEGER_NUMBER_FORMAT,
  CBU_PATTERN_OTHER_BANKS_MESSAGE,
} from '../constants/form';
import { CBU_SAME_BANK_ENABLED } from '../constants/settings';

const cbuRules = {
  required,
  minLength: {
    message: CBU_LENGTH_MESSAGE,
    value: CBU_LENGTH,
  },
  maxLength: {
    message: CBU_LENGTH_MESSAGE,
    value: CBU_LENGTH,
  },
  validate: {
    checkNumber: (value: string) => INTEGER_NUMBER_FORMAT.test(value) || CBU_INVALID_PATTERN_MESSAGE,

    checkCVU: (value: string) => CBU_CVU_PATTERN.test(value) || CBU_CVU_PATTERN_MESSAGE,

    checkSameBank: (value: string) => CBU_SAME_BANK_ENABLED || CBU_PATTERN_OTHER_BANKS.test(value) || CBU_PATTERN_OTHER_BANKS_MESSAGE,
  },
};

const aliasRules = {
  required,
  minLength: {
    message: `Debe tener al menos ${CBU_ALIAS_MIN_LENGTH} caracteres`,
    value: CBU_ALIAS_MIN_LENGTH,
  },
  maxLength: {
    message: `Debe tener hasta ${CBU_ALIAS_MAX_LENGTH} caracteres`,
    value: CBU_ALIAS_MAX_LENGTH,
  },
  pattern: {
    message: INPUT_INVALID_FORMAT_MESSAGE,
    value: CBU_ALIAS_PATTERN,
  },
};

export const FixedTermNewRules: Record<string, Record<keyof IFixedTermItem & ICBU, Record<string, ValidationRule>>> = {
  rules: {
    cbuOption: { required },
    cbu: cbuRules,
    alias: aliasRules,
    NotPep: { required },
    NotSoi: { required },
    NotFatca: { required },
  },
};
